import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { KeyRound, CheckCircle, XCircle } from 'lucide-react';

export default function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [tokenValido, setTokenValido] = useState(null);
  const [tipoUsuario, setTipoUsuario] = useState(null);
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  useEffect(() => {
    if (!token) { setTokenValido(false); return; }
    axios.get(`/api/recuperar-senha/verificar/${token}`)
      .then(res => { setTokenValido(true); setTipoUsuario(res.data.tipo); })
      .catch(() => setTokenValido(false));
  }, [token]);

  const redefinir = async (e) => {
    e.preventDefault();
    if (novaSenha !== confirmarSenha) { toast.error('As senhas não coincidem!'); return; }
    if (novaSenha.length < 6) { toast.error('A senha deve ter pelo menos 6 caracteres!'); return; }
    setSalvando(true);
    try {
      await axios.post('/api/recuperar-senha/redefinir', { token, novaSenha });
      setSucesso(true);
      toast.success('Senha redefinida com sucesso!');
      const destino = tipoUsuario === 'vereador' ? '/login/vereador' : '/login/admin';
      setTimeout(() => navigate(destino), 3000);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Erro ao redefinir senha');
    } finally { setSalvando(false); }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <div style={{ fontSize: '3rem', marginBottom: 8 }}>🔑</div>
          <h1>Câmara Digital</h1>
          <p>Redefinição de Senha</p>
        </div>

        {tokenValido === null && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div className="spinner" style={{ margin: '0 auto' }} />
            <p style={{ marginTop: 12, color: 'var(--texto-suave)' }}>Verificando token...</p>
          </div>
        )}

        {tokenValido === false && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <XCircle size={48} color="var(--reprovado)" style={{ margin: '0 auto 12px', display: 'block' }} />
            <h3 style={{ color: 'var(--reprovado)', marginBottom: 8 }}>Link inválido ou expirado</h3>
            <p style={{ color: 'var(--texto-suave)', fontSize: '0.875rem', marginBottom: 20 }}>
              Solicite um novo link de recuperação.
            </p>
            <Link to="/login/admin" className="btn btn-primary" style={{ display: 'inline-flex' }}>
              Voltar ao Login
            </Link>
          </div>
        )}

        {tokenValido === true && !sucesso && (
          <form onSubmit={redefinir}>
            <div className="form-group">
              <label className="form-label"><KeyRound size={12} style={{ display: 'inline', marginRight: 4 }} />Nova Senha</label>
              <input className="form-input" type="password" value={novaSenha} onChange={e => setNovaSenha(e.target.value)} placeholder="Mínimo 6 caracteres" required />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmar Nova Senha</label>
              <input className="form-input" type="password" value={confirmarSenha} onChange={e => setConfirmarSenha(e.target.value)} placeholder="Repita a senha" required />
            </div>
            <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', marginTop: 8 }} type="submit" disabled={salvando}>
              {salvando ? 'Salvando...' : '✅ Redefinir Senha'}
            </button>
          </form>
        )}

        {sucesso && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <CheckCircle size={48} color="var(--aprovado)" style={{ margin: '0 auto 12px', display: 'block' }} />
            <h3 style={{ color: 'var(--aprovado)', marginBottom: 8 }}>Senha redefinida!</h3>
            <p style={{ color: 'var(--texto-suave)', fontSize: '0.875rem' }}>
              Redirecionando para o login...
            </p>
          </div>
        )}
      </div>
    </div>
  );
}